import { all, call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get, api_put, api_post } from "services/api";
import { status } from "helpers/statusVariable";
import { orderArray } from "helpers/orderArray";
import { timeStatus } from "helpers/timeStatus";
import moment from "moment";
import { agentList } from "helpers/agentList";
import { fixTime } from "helpers/dateTools";
import { SET_SNACKBAR_SEARCH, START_REQUEST_SEARCH, STOP_REQUEST_SEARCH } from "redux/reducers/search/searchReducer";

// orders
const LOAD_ORDERS_ORDERS = "LOAD_ORDERS_ORDERS";
const SET_ORDERS_ORDERS = "SET_ORDERS_ORDERS";

// menu orders
const TOGGLE_MENU = "TOGGLE_MENU";

// order change status
const SEND_NEW_STATUS_ORDER_ORDERS = "SEND_NEW_STATUS_ORDER_ORDERS";
const SET_NEW_STATUS_ORDER_ORDERS = "SET_NEW_STATUS_ORDER_ORDERS";

//Order coment
const SEND_NEW_COMMENT_ORDER_ORDERS = "SEND_NEW_COMMENT_ORDER_ORDERS";

// filters
const CHANGE_AGENT_ORDERS = "CHANGE_AGENT_ORDERS";
const SWITCH_STATE_ORDERS = "SWITCH_STATE_ORDERS";

// general
const CLEAR_DATA_ORDERS = "CLEAR_DATA_ORDERS";


const INITIAL_STATE = {
  orders: [],
  timing: {
    ON_TIME: [],
    DELAYED: [],
    LATE: [],
    FINISHED: [],
  },
  units: [],
  unitsPortable: [],
  unitsStacionary: [],
  agents: agentList,
  //annotations
  annotations: [],
  // filters
  agentSelected: "",
  // menu orders
  menuOrders: {
    ON_TIME: true,
    DELAYED: true,
    LATE: true,
    FINISHED: true,
  },
  switchState: false
};

const ordersReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    // orders
    case LOAD_ORDERS_ORDERS:
      return {
        ...state,
        orders: [],
        timing: {
          ON_TIME: [],
          DELAYED: [],
          LATE: [],
          FINISHED: [],
        },
        units: [],
        unitsPortable: [],
        unitsStacionary: [],
        ordersSelected: [],
        ordersIDSelected: [],
      };
    case SET_ORDERS_ORDERS:
      return {
        ...state,
        orders: payload.orders,
        timing: {
          ON_TIME: payload.onTime,
          DELAYED: payload.delayed,
          LATE: payload.offTime,
          FINISHED: payload.programmed,
        },
        units: payload.units,
        unitsPortable: payload.unitsPortable,
        unitsStacionary: payload.unitsStacionary,
      };
    case CLEAR_DATA_ORDERS:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    // menu orders
    case TOGGLE_MENU: {
      return {
        ...state,
        menuOrders: {
          ...state.menuOrders,
          [payload.field]: !state.menuOrders[payload.field],
        },
      };
    }
    //filter
    case CHANGE_AGENT_ORDERS:
      return {
        ...state,
        agentSelected: payload,
      };
    // order change status
    case SET_NEW_STATUS_ORDER_ORDERS:
      const newTiming = {
        ON_TIME: [],
        DELAYED: [],
        LATE: [],
        FINISHED: [],
      }
      const stringy = JSON.stringify(state)
      let newState = JSON.parse(stringy)
      const newOrders = newState.orders.map(item => {
        if (item.id === payload.order.id) {
          newTiming[payload.order.timing] = [...newTiming[payload.order.timing], payload.order];
        } else {
          newTiming[item.timing] = [ ...newTiming[item.timing], item]
        }
        return item.id === payload.order.id ? payload.order : item
      });
      return {
        ...newState,
        orders: newOrders,
        timing: newTiming,
      };
    case SWITCH_STATE_ORDERS:
      return {
        ...state,
        switchState: !state.switchState
      }
    default:
      return state;
  }
};

// Actions
function getOrders(stations, startDate, endDate, switchState) {
  return {
    type: LOAD_ORDERS_ORDERS,
    payload: {
      stations,
      startDate,
      endDate,
      switchState
    },
  };
}
function switchFilters() {
  return {
    type: SWITCH_STATE_ORDERS,
  };
}
function toggleMenuAction(field) {
  return {
    type: TOGGLE_MENU,
    payload: {
      field,
    },
  };
}
function sendStatus(id, body) {
  return {
    type: SEND_NEW_STATUS_ORDER_ORDERS,
    payload: {
      id,
      body,
    },
  };
}
function sendComment(id, body) {
  return {
    type: SEND_NEW_COMMENT_ORDER_ORDERS,
    payload: {
      id,
      body
    }
  }
}
function changeAgent(station) {
  return {
    type: CHANGE_AGENT_ORDERS,
    payload: station,
  };
}
function clearOrders() {
  return {
    type: CLEAR_DATA_ORDERS,
  };
}

// sagas
function* fetchOrders(action) {
  const {
    payload: { stations = [], startDate, endDate, switchState },
  } = action;
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/services?`;
  let urlUnits = `${process.env.REACT_APP_URL}${PROYECT}/units?`;

  let urlStations = `start=${startDate}&end=${endDate}`;
  if ( stations && !switchState) {
    stations.forEach((station) => {
      urlStations = `${urlStations}&stations=${station.value}`;
      urlUnits = `${urlUnits}&stations=${station.value}`;
    });
  }
  if (switchState) {
    stations.forEach((station) => {
      urlStations = `${urlStations}&agent=${station.label}`;
    });
  }
  const url = `${baseUrl}${urlStations}`;
  try {
    yield put({type: START_REQUEST_SEARCH});
    let [response, units] = yield all([
      call(api_get, url, auth),
      call(api_get, urlUnits, auth),
    ]);
    response = response.map((order) => {
      return {
        ...order,
        status: status[order.status.toUpperCase()],
        isSelected: false,
      };
    });

    const orderedUnits = orderArray(units, "number").map((unit) => {
      return {
        ...unit,
        value: unit.id,
        label: `${unit.number}`,
      };
    });
    const newOrdersOnTime = response.filter(
      (order) => order.timing === timeStatus.ON_TIME.value
    );
    const newOrdersDelayed = response.filter(
      (order) => order.timing === timeStatus.DELAYED.value
    );
    const newOrdersOffTime = response.filter(
      (order) => order.timing === timeStatus.LATE.value
    );
    const newOrdersProgrammed = response.filter(
      (order) => order.timing === timeStatus.FINISHED.value
    );

    yield put({
      type: SET_ORDERS_ORDERS,
      payload: {
        orders: response,
        onTime: newOrdersOnTime,
        delayed: newOrdersDelayed,
        offTime: newOrdersOffTime,
        programmed: newOrdersProgrammed,
        units: orderedUnits ? orderedUnits : [],
      },
    });
  } catch (message) {
    yield put({
      type: SET_SNACKBAR_SEARCH,
      payload: {
        message,
        color: 'danger'
      },
    });
  }
  yield put({type: STOP_REQUEST_SEARCH});
}

function* sendNewStatus(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id, body },
  } = action;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/services/${id}`;
  try {
    yield put({type: START_REQUEST_SEARCH});
    const response = yield call(api_put, url, body, auth);

    const newOrder = response[0];
    const normalizedOrder = {
      ...newOrder,
      status: status[newOrder.status.toUpperCase()],
    };
    yield put({
      type: SET_NEW_STATUS_ORDER_ORDERS,
      payload: {
        order: normalizedOrder,
      },
    });
  } catch (message) {
    yield put({
      type: SET_SNACKBAR_SEARCH,
      payload: {
        message,
        color: 'danger'
      },
    });
  }
  yield put({type: STOP_REQUEST_SEARCH});
}

function* sendNewComment(action) {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const {
    payload: { id, body },
  } = action;
  const urlCmts = `${process.env.REACT_APP_URL}${PROYECT}/services/${id}/annotations`;
  //state params
  const stationSelected = yield select((state) => state.orders.stationSelected);
  const startDate = yield select((state) => state.orders.startDate);
  const endDate = yield select((state) => state.orders.endDate);

  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/services?`;

  let urlUnits = `${process.env.REACT_APP_URL}${PROYECT}/units?`;
  let urlStations = `start=${startDate ? startDate: moment().format('YYYY-MM-DD')}&end=${endDate ? endDate : moment().format('YYYY-MM-DD')}`;

  if (stationSelected) {
    stationSelected.forEach((station) => {
      urlStations = `${urlStations}&stations=${station.value}`;
      urlUnits = `${urlUnits}&stations=${station.value}`;
    });
  }
  
  const url = `${baseUrl}${urlStations}`;


  try {
    yield put({type: START_REQUEST_SEARCH});
    const responseCmts = yield call(api_post, urlCmts, body, auth);
    // debugger
    const hour = new Date().getHours()
    const hourRecieved = new Date(responseCmts.annotations[0].created).getHours()
    
    if( hour !== hourRecieved ) {
      const newTime = fixTime(responseCmts.annotations[0].created)
      responseCmts.annotations[0].created = newTime
    }
    const UpdateResponseCmts = {
      ...responseCmts,
      status: status[responseCmts.status.toUpperCase()]
    }

    let [response, units] = yield all([
      call(api_get, url, auth),
      call(api_get, urlUnits, auth),
    ]);
    response = response.map((order) => {
      return {
        ...order,
        status: status[order.status.toUpperCase()],
        isSelected: false,
      };
    });

    const orderedUnits = orderArray(units, "number").map((unit) => {
      return {
        ...unit,
        value: unit.id,
        label: `${unit.number}`,
      };
    });

    const newOrders = [...response];

    const indexRow = newOrders.findIndex((order) => order.id === id);
    
    if (indexRow !== -1) {
      newOrders[indexRow] = UpdateResponseCmts;
    }
    
    const newOrdersOnTime = newOrders.filter(
      (order) => order.timing === timeStatus.ON_TIME.value
    );
    const newOrdersDelayed = newOrders.filter(
      (order) => order.timing === timeStatus.DELAYED.value
    );
    const newOrdersOffTime = newOrders.filter(
      (order) => order.timing === timeStatus.LATE.value
    );
    const newOrdersProgrammed = newOrders.filter(
      (order) => order.timing === timeStatus.FINISHED.value
    );

    yield put({
      type: SET_ORDERS_ORDERS,
      payload: {
        orders: newOrders,
        onTime: newOrdersOnTime,
        delayed: newOrdersDelayed,
        offTime: newOrdersOffTime,
        programmed: newOrdersProgrammed,
        units: orderedUnits ? orderedUnits : [],
      },
    });

    yield put({
      type: SET_SNACKBAR_SEARCH,
      payload: {
        message: "Guardado con éxito!",
        color: 'success'
      }
    });
    
  } catch (message) {
    yield put({
      type: SET_SNACKBAR_SEARCH,
      payload: {
        message,
        color: 'danger'
      },
    });
  }
  yield put({type: STOP_REQUEST_SEARCH});
}


function* ordersSaga() {
  yield takeLatest(LOAD_ORDERS_ORDERS, fetchOrders);
  yield takeLatest(SEND_NEW_STATUS_ORDER_ORDERS, sendNewStatus);
  yield takeLatest(SEND_NEW_COMMENT_ORDER_ORDERS, sendNewComment);
}

export {
  // reducer
  ordersReducer,
  // actions
  getOrders,
  sendStatus,
  sendComment,
  switchFilters,
  clearOrders,
  //filter
  changeAgent,
  // menu orders
  toggleMenuAction,
  // saga
  ordersSaga,
};
